export const TOGGLE_ICON_SIZE = 12;
